import { Action as ReduxAction } from 'redux';

import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { ICollectionInfo } from '../../Collections/ICollectionInfo';
import { openContentDetailDialog } from '../../../actions/spaces/OpenContentDetailDialogActions';
import { AppState } from '../../../state/AppState';
import { isCollectionSpace } from '../../../state/SpaceInfo';

export const CollectionDetailsAction: IEntityAction<ICollectionInfo, {}> = {
  name: EntityActionNames.CollectionDetails,
  translateName: Messages.collectionsDetailsMenu,
  isVisible: (_targetItems: ICollectionInfo[], state: AppState) => {
    return FeatureFlags.collectionsEnabled && isCollectionSpace(state.spaceInfo);
  },
  isClickable: (_availableActions: {}, targetItems: ICollectionInfo[]) => {
    if(targetItems.length !== 1) return false;

    const item = targetItems[0];
    return item.contentType === 'collection';
  },
  createReduxAction: (targetItems: ICollectionInfo[]): ReduxAction => {
    return openContentDetailDialog(targetItems[0]);
  },
};

